module.exports = __webpack_public_path__ + "static/assets/a72a652fdc84dc6983d3cc9596c36a26.svg";